module.exports = __webpack_public_path__ + "static/doughnut-economics-db0de8062db124816ed261bb51f4e2df.jpg";